import firestore from "../firebase/firestore";

export async function saveUtilityMinutes(items, agent) {
  try {
    if (!items || !Array.isArray(items) || items.length === 0) {
      throw new Error("A lista de itens é inválida");
    }
    if (!agent) {
      throw new Error("O usuário solicitante é inválido");
    }

    const docRef = await firestore
      .collection("utility_minutes")
      .add({
        created_at: new Date(),
        list_ids: items,
        requested_by: agent,
        status: "pending",
      })
      .catch((err) => {
        throw new Error("Erro ao criar a ata no banco de dados: " + err);
      });

    const checkStatus = async (docRef) => {
      const doc = await docRef.get();
      return doc.exists && doc.data().status !== "pending";
    };

    const waitForStatusChange = async (
      docRef,
      interval = 1000,
      timeout = 120000,
    ) => {
      const startTime = Date.now();
      while (Date.now() - startTime < timeout) {
        if (await checkStatus(docRef)) {
          return docRef.get();
        }
        await new Promise((resolve) => setTimeout(resolve, interval));
      }
      throw new Error("Tempo de espera de criação do documento excedido.");
    };

    const updatedDoc = await waitForStatusChange(docRef);

    if (updatedDoc.data().status === "error") {
      throw new Error("Erro na criação do documento.");
    }

    return updatedDoc.data().file_url;
  } catch (err) {
    throw err;
  }
}
